import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AreaCardData, AreaInfo } from 'ais-facade-api/api';

interface State {
  marineInfrasctructureResult: any;
  selectedArea: AreaInfo | AreaCardData | null;
  showAreaCard: boolean;
}

const initialState: State = {
  marineInfrasctructureResult: {},
  selectedArea: null,
  showAreaCard: false,
};

export const marineInfrastructureReducer = createSlice({
  name: 'marineInfrasctructureSlice',
  initialState,
  reducers: {
    setMarineInfrasctructureResult: (state, action: PayloadAction<any>) => {
      state.marineInfrasctructureResult = action.payload;
    },
    setSelectedArea: (state, action: PayloadAction<AreaInfo | AreaCardData | null>) => {
      state.selectedArea = action.payload;
    },
    setShowAreaCard: (state, action: PayloadAction<boolean>) => {
      state.showAreaCard = action.payload;
    },
  },
});

export const { setMarineInfrasctructureResult, setSelectedArea, setShowAreaCard } = marineInfrastructureReducer.actions;
export default marineInfrastructureReducer.reducer;
